import { Helmet } from "react-helmet-async";

const StructuredData = ({ article }) => {
  if (!article) return null;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": article.title,
    "image": article.image_url || "https://financasinfo.preview.emergentagent.com/og-image.png",
    "datePublished": article.published_date,
    "dateModified": article.created_at,
    "author": {
      "@type": "Organization",
      "name": "FinaNews",
      "url": "https://financasinfo.preview.emergentagent.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "FinaNews",
      "logo": {
        "@type": "ImageObject",
        "url": "https://financasinfo.preview.emergentagent.com/logo.png"
      }
    },
    "description": article.rewritten_content.substring(0, 200) + "...",
    "articleSection": article.category,
    "inLanguage": "pt-BR",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://financasinfo.preview.emergentagent.com/news/${article.id}`
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;